import React from "react";
import "../css/SchoolsAndClubsPage.css"; 
import ScrollToTop from "./Tiltop";

import {
FaLightbulb,
FaUserTie,
FaChalkboardTeacher,
} from "react-icons/fa";


const SchoolsAndClubsPage = () => {


  return (
    <div className="main-content">

      {/* HERO SECTION */}

          <section className="heroforegdrag" id="foredrag">
        <div className="heroforegdrag-content">

          <p>Foredrag, Workshops & Læringsforløb</p>
          <h1>Gaming, ansvar & <span className="gold">Digital trivsel</span> i børnenes højde</h1>

          <p className="heroforegdrag-sub">
            Samme faglige fundament, tre forskellige formater. <br/>
            Hos Linx Legacy Academy arbejder vi med de samme gennemprøvede moduler 
            på tværs af alle vores formater. 
            Forskellen ligger ikke i indholdet men i tiden, dybden og graden 
            af involvering. vi tager altid udgangspunkt i jeres virkelighed og mål.
          </p>

        </div>
        </section>
        



      {/* FEATURES / OFFERINGS */}
      <section className="featuresschool">
<div className="featureschool-box">
<FaUserTie className="icon" />
<h3>Foredrag</h3>
<p>Inspirerende oplæg om gaming, digital trivsel og sociale færdigheder.</p>
</div>

<div className="featureschool-box">
<FaLightbulb className="icon" />
<h3>Workshops</h3>
<p>Praktisk træning af færdigheder med dialog og konkrete udfordringer 
  fra hverdagen.</p>
</div>

<div className="featureschool-box">
<FaChalkboardTeacher className="icon" />
<h3>Læringsforløb</h3>
<p>Udvidede forløb, der kombinerer gaming med faglige mål og personlig udvikling.</p>
</div>
      </section>




       {/* foredrag */}
         <section className="content-layout">
         <article className="article">
          <h2>Vælg det format der passer best til jeres behov</h2>
          <p>
          Gaming er for mange børn og unge meget mere end underholdning.<br/> 
          Det er fællesskab, kommunikation og læring men også et 
          område, der kan skabe spørgsmål og 
          udfordringer for de voksne omkring dem.
          </p>
          <p>
          Derfor tilbyder vi det samme faglige indhold i tre forskellige formater.<br/> 
          Forskellen ligger i tiden, graden af involvering og hvor dybt vi arbejder med stoffet.<br/><br/>    
          <span className="gold">Foredrag</span> skaber fælles forståelse og nye perspektiver.<br/>  
          <span className="gold">Workshoppen</span> omsætter viden til praksis.<br/> 
          <span className="gold">Læringsforløb</span> giver mulighed for fordybelse og varig forankring.<br/><br/>   
          Uanset format tager vi udgangspunkt i jeres hverdag og 
          målgruppe, så indsatsen bliver relevant, anvendelig og 
          til at arbejde videre med.
          </p>
        </article>

        <aside className="facts">
          <h3>Overblik</h3>
          <div className="facts-sub">
            Gaming, dannelse &amp; digitale trivsel
          </div>
          <p>Format</p>
          <ul>
            <li>Foredrag</li>
            <li>Workshop</li>
            <li>Læringsforløb</li>
          </ul>
          <p>Varighed</p>
          <ul>
            <li>Foredrag: ca. 2 timer</li>
            <li>Workshop: 1-3 dage</li>
            <li>Læringsforløb: Tilpasses (uger/måneder)</li>
          </ul>
          <div className="facts-sub">
            Udbytte Fælles sprog mellem børn og voksne Konkrete 
            redskaber til hverdagen 
            Øget forståelse for unges digitale liv
          </div>


        </aside>
      </section>

      <section className="modules-section">
       <h2>her ses pensum opdelt i moduler</h2>
        <div className="modules-grid">
          <div className="module-card">
            <div className="module-top">
              <div>
                <div className="module-emoji">🧩</div>
                <div className="module-title">Modul 1 · Introduktion til Gaming &amp; Esport</div>
              </div>
            </div>
            <div className="module-sub">Give deltagerne grundlæggende forståelse af gaming og esport.</div>
            <ul className="module-list">
              <li>Hvad er gaming og esport?</li>
              <li>Motivation: hvorfor gamer unge?</li>
              <li>Populære spil og deres betydning for unge</li>
              <li>forældreperspektiv og guide</li>
            </ul>
          </div>

          <div className="module-card">
            <div className="module-top">
              <div>
                <div className="module-emoji">🛡️</div>
                <div className="module-title">Modul 2 · Digital trivsel & Sikkerhed</div>
              </div>
            </div>
            <div className="module-sub">
              Skabe forståelse for ansvarlig onlineadfærd og digitale grænser.
            </div>
            <ul className="module-list">
              <li>Sikkerhed online: passwords, 2FA, og digitale scams</li>
              <li>Værktøjer til at forstå spil og køb i spil (PEGI, lootboxes)</li>
              <li>God kommunikation og tone online</li>
              <li>Konflikthåndtering i digitale rum</li>
            </ul>
          </div>

          <div className="module-card">
            <div className="module-top">
              <div>
                <div className="module-emoji">🤝</div>
                <div className="module-title">Modul 3 · Online relationer & fællesskaber</div>
              </div>
            </div>
            <div className="module-sub">
              Undersøge sociale aspekter af gaming og onlinefællesskaber.
            </div>
            <ul className="module-list">
              <li>Opbygning af sociale relationer online</li>
              <li>Håndtering af toxic behavior og mobning</li>
              <li>Skærmtid vs. skærmkvalitet: balance mellem online og offline</li>
              <li>Konflikter online vs. offline</li>
            </ul>
          </div>

          <div className="module-card">
            <div className="module-top">
              <div>
                <div className="module-emoji">🌍</div>
                <div className="module-title">Modul 4 · Gaming & Socialt Samvær</div>
              </div>
            </div>
            <div className="module-sub">
              Fokus på gaming som socialt værktøj og forebyggelse af isolation.
            </div>
            <ul className="module-list">
              <li>Gaming som socialt værktøj</li>
              <li>Skabe trygge fællesskaber</li>
              <li>Risiko-tegn på social isolation</li>
            </ul>
          </div>

          <div className="module-card">
            <div className="module-top">
              <div>
                <div className="module-emoji">🧠</div>
                <div className="module-title">
                  Modul 5 · Gaming i Undervisning & Pædagogik
                </div>
              </div>
            </div>
            <div className="module-sub">
              Inspirere til, hvordan gaming kan anvendes i læring og udvikling.
            </div>
            <ul className="module-list">
              <li>Samarbejde, roller og teamdynamik</li>
              <li>Kritisk tænkning gennem spil</li>
              <li>Kreative muligheder i spil</li>
            </ul>
          </div>

          <div className="module-card">
            <div className="module-top">
              <div>
                <div className="module-emoji">🎮</div>
                <div className="module-title">Modul 6 · Forstå Spillene</div>
              </div>
            </div>
            <div className="module-sub">
              Gå i dybden med elevernes egne spil og digitale vaner.
            </div>
            <ul className="module-list">
              <li>Introduktion til konkrete spil og deres mekanikker</li>
              <li>Analyse af strategier, samarbejde og kompetencer</li>
              <li>Sikkerhed og adfærd på platforme som Discord</li>
            </ul>
          </div>
        </div>
      </section>



<section className="modules-section">
<article className="article">
    <h2>Svært ved at vælge?</h2>
  <div className="boxes">

    <div className="box">
      <h3>Foredrag</h3>
      <p className="subtitle">
        Når I vil inspirere og skabe fælles forståelse
      </p>

      <p>
        Vores foredrag er intense, nærværende og involverende.
        På kort tid giver vi deltagerne nye perspektiver,
        genkendelse og konkrete indsigter, som kan mærkes med det samme.
      </p>

      <ul>
        <li>Vil inspirere og skabe refleksion</li>
        <li>Ønsker et fælles sprog og fælles forståelse</li>
        <li>Har begrænset tid, men vil have høj kvalitet</li>
      </ul>

      <p>
        <span className="gold"><strong>Varighed:</strong></span> ca. 2 timer
      </p>

    </div>

    <div className="box">
      <h3>Workshop</h3>
      <p className="subtitle">
        Når I vil træne færdigheder i praksis
      </p>

      <p>
        Workshops bygger videre på foredragets indsigter og
        omsætter dem til handling. Her arbejder vi aktivt med
        øvelser, dialog og konkrete situationer fra deltagernes hverdag.
      </p>

      <ul>
        <li>Vil udvikle konkrete kompetencer</li>
        <li>Ønsker høj deltagerinvolvering</li>
        <li>Vil arbejde med virkelige udfordringer</li>
      </ul>
      <p>
      <span className="gold"><strong>Varighed:</strong></span> 1-3 dage
      </p>
    </div>

    <div className="box">
      <h3>Læringsforløb</h3>
      <p className="subtitle">
        Når I vil skabe varig forandring
      </p>

      <p>
        Læringsforløbet er vores mest dybdegående format.
        Her arbejder vi med fuldt pensum, gentagelse,
        refleksion og implementering over tid så ny adfærd
        faktisk bliver en del af hverdagen.
      </p>

      <ul>
        <li>Ønsker reel og varig adfærdsændring</li>
        <li>Vil arbejde strategisk med mennesker og kultur</li>
        <li>Er klar til at investere tid i udvikling</li>
      </ul>

      <p>
        <span className="gold"><strong>Varighed:</strong> </span> Tilpasses typisk over flere uger eller måneder
      </p>
    </div>

  </div>
</article>

</section>








       <section className="bottom">
        <div>
         <div className="mango">   
          <h2>Om underviserne</h2>
          <p>
          <br/>
          Hos Linx Legacy Academy bliver undervisningen varetaget af Lui og Matii, 
          som begge brænder for at udvikle børn og unge både fagligt, socialt og personligt.
          </p>
          <p>
          Hos os handler det ikke kun om undervisning,
          det handler om at bygge selvtillid, fællesskab og stærke værdier, 
          som eleverne kan tage med sig videre i livet.
          </p>

          </div>

          <div className="teachers">            
            <div className="teacher-card">              
              <div className="teacher-header">
                <div>
                <div className="teacher-name">Mathias</div>
                <div className="teacher-role">pædagogisk erfaring & Esportstræner</div>
                </div>
                <div className="teacher-avatar">                
                  <img
                    src="/under1.png"
                    alt="Underviser 1"
                  />
                </div>
              </div>
              <p className="teacher-bio">
                Jeg har flere års erfaring med børn og unges trivsel og udvikling i esport klubber og
                skolemiljøer. <br/>
                Brænder for at bygge bro mellem voksne og unges
                digitale liv.
              </p>
            </div>

            <div className="teacher-card">
              <div className="teacher-header">
                <div>
                <div className="teacher-name">Lui</div>
                <div className="teacher-role">Digital dannelse</div>
                </div>
                <div className="teacher-avatar">
                  <img
                    src="/under2.png"
                    alt="Underviser 2"
                  />
                </div>
              </div>
              <p className="teacher-bio">
                Jeg arbejder med digital dannelse, konflikthåndtering og
                fællesskaber både online og offline. <br/>
                Fokus på konkrete redskaber til hverdagen.
              </p>
            </div>
          </div>      
            
        </div>




          <div className="mango-2">   
          <p>
          <h2>Er du i tvivl</h2>
          <br/>
          Mange starter med et foredrag og bygger videre derfra. 

          Vi hjælper jer gerne med at vælge det format, der giver mest mening for jeres situation.</p>

          <aside className="contact">

          <h2>Kontakt &amp; booking</h2>
          <p>
            Vil du høre mere eller booke forløbet til jeres skole, klub eller
            forældreaften? Skriv eller ring - så finder vi en model, der passer
            til jer.
          </p>

          <div className="contact-grid">
            <div className="contact-item">
              <div className="contact-label">E-mail</div>
              <a href="mailto:info@dinmail.dk">Academy@linxlegacy.dk</a>
            </div>
            <div className="contact-item">
            </div>
            <div className="contact-item">
              <div className="contact-label">Lokation</div>
              <div>Sjælland · efter aftale</div>
            </div>
            <div className="contact-item">
              <div className="contact-label">Målgruppe</div>
              <div>indskoling, Udskoling, klubber, forældre &amp; fagpersoner</div>
            </div>
          </div>
          <div className="contact-note">
            Skriv gerne ønsket dato, målgruppe og ca. antal deltagere.
          </div>       
        
        </aside>
       </div>
      </section>


    <ScrollToTop />

    </div>
    
  );
  
};

export default SchoolsAndClubsPage;